import type { ProcessQuestionnairesProgressStatusItem } from '@common/interfaces/api/processesApi';
import { QuestionnaireResponse } from './QuestionnaireResponse';

interface IQuestionnaireResponsesProps {
    questionnaireResponsesResults: ProcessQuestionnairesProgressStatusItem[];
}

export function QuestionnaireResponses(props: Readonly<IQuestionnaireResponsesProps>) {
    const { questionnaireResponsesResults } = props;

    const completedQuestionnaires = questionnaireResponsesResults
        .filter((item) => item.percentage === 100)
        .map((item) => {
            return (
                <QuestionnaireResponse
                    key={item.name}
                    processQuestionnaireResponseId={item.processQuestionnaireResponseId ?? ''}
                    questionnaireName={item.name}
                />
            );
        });

    return <>{completedQuestionnaires}</>;
}
